import type { PageContent } from "../types";

export const privacy_policy: PageContent = {
  slug: "privacy-policy",
  title: `Privacy Policy | Phil Carr`,
  description: `Read the privacy policy for Phil Carr, outlining how we collect, use, and protect personal data for SEO and web design services.`,
  body: `# Privacy Policy

This privacy policy explains how Phil Carr ("we", "us", or "our") collects, uses,
and protects your personal information when you visit our website or enquire about SEO and web
design services. I may collect personal information you submit through contact forms, email enquiries, or phone
calls.

## Information we collect

Personal information can include your name, email address, phone number, business details, and information
relevant to your project.

## How we use your information

- To respond to enquiries and provide requested services.
- To prepare proposals, contracts, and project communications.
- To improve this website, services, and customer experience.
- To meet legal, regulatory, or contractual obligations.

## Lawful basis for processing

Personal data is processed based on legitimate interests (to run and grow the business), consent
(when you opt in), and contractual necessity (to deliver agreed services).

## Cookies and analytics

With your permission, optional analytics and marketing cookies may measure visits, enquiries,
content performance, and advertising performance. Optional tags load only after you accept
optional cookies. You can reject or withdraw consent using **Cookie settings** on any page.
Form enquiries still work without optional cookies. See our [cookie policy](/cookies) for
details.

## Sharing your information

Personal data is never sold. Information may be shared with trusted suppliers who support
service delivery (such as hosting or analytics providers) when necessary and under appropriate
confidentiality agreements.

## Appointment bookings

When you book a call, your name, email address, phone number, chosen appointment time and any
notes you provide are used to arrange and deliver the call. These details are stored securely
on our hosting server and in our Google and Microsoft calendars. The public booking calendar
shows available and unavailable times only; it does not display existing appointment details.
An essential session cookie protects booking submissions. Your browser may also keep a booking
reference in session storage so you can recover the confirmation if you reload the page.
Local records of confirmed bookings are removed 90 days after the appointment by our scheduled
maintenance job. Calendar entries and unresolved bookings are retained as needed to provide
the service or resolve the enquiry. To change a booking or request deletion, contact us below.

## Website chat

The website assistant answers questions using information from this website. When AI replies are enabled, chat messages and relevant excerpts from public website pages are sent to Anthropic's Claude service to generate an answer. Phil can take over the same conversation. Chat messages are stored on the website's hosting server so the conversation and any follow-up remain available when the assistant is offline.

If you ask for a personal reply, we collect the name and email address or phone number you choose to provide, with your agreement to be contacted about that enquiry. Inbox and email alerts tell Phil that a visitor needs attention. Please do not send passwords, payment details or sensitive personal information through chat.

An essential chat cookie keeps your conversation separate from other visitors' conversations. Chat records are scheduled for removal after 90 days without activity; cleanup runs when the chat service is used. You can ask for earlier deletion using the contact details below. Our legitimate interests in answering enquiries support chat processing, and your consent covers using the contact details you submit for a follow-up.

## Data retention

Personal data is retained only for as long as needed to provide services, meet legal requirements, or
resolve disputes. You can request deletion where applicable.

## Your rights

You have the right to access, correct, or request deletion of your personal information. You can also
object to processing or request data portability. To exercise these rights, contact me using the
details below.

## Contact details

If you have questions about this privacy policy, please email [info@phil-carr.co.uk](mailto:info@phil-carr.co.uk) or call 01226 697 325.

## Updates to this policy

This privacy policy may be updated occasionally to reflect changes in services or legal
obligations. The latest version will always be published on this page.

[Back to Top](/#top)`,
};
